var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"primary-button",class:_vm.buttonClasses,attrs:{"type":"button","disabled":!_vm.enabled},on:{"mouseenter":_vm.mouseEnter,"focusin":_vm.mouseEnter}},[_c('span',[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }